export default "__VITE_ASSET__e13a11af__"